/**
 * Cryptographically strong random helpers (prefer over Math.random for Sonar S2245).
 */

/** Float in [0, 1). */
export const secureRandom = (): number => {
  const buf = new Uint32Array(1);
  crypto.getRandomValues(buf);
  return buf[0] / 0x1_0000_0000;
};

/** Integer in [0, maxExclusive). */
export const secureRandomInt = (maxExclusive: number): number => {
  if (maxExclusive <= 0) { return 0; }
  return Math.floor(secureRandom() * maxExclusive);
};
